import { render, staticRenderFns } from "./MonthlySales.vue?vue&type=template&id=66c1c142&scoped=true&"
import script from "./MonthlySales.vue?vue&type=script&lang=ts&"
export * from "./MonthlySales.vue?vue&type=script&lang=ts&"
import style0 from "./MonthlySales.vue?vue&type=style&index=0&id=66c1c142&prod&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66c1c142",
  null
  
)

export default component.exports